import { Metamodel } from 'app/model/base/model';
import { Named } from 'app/model/base/named';
import { IModel, IAttribute } from 'app/model/base/annotation';

@Metamodel.model({
    abstract: true
})
export abstract class StoreWriteSettings extends Named {
    public static readonly MODEL: IModel;
    public static readonly MAX_CONCURRENT_CONNECTIONS: IAttribute;
    public static readonly COPY_BEHAVIOR: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'MAX_CONCURRENT_CONNECTIONS',
        display: stringResources.ModelName_MaxConcurrentConnections,
        constraint: {
            whole: true,
            minimum: 0
        }
    })
    public maxConcurrentConnections?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'COPY_BEHAVIOR',
        display: stringResources.ModelName_CopyBehavior
    })
    public copyBehavior?: string;

    public recoverPropFromPrevOne(prevStoreSettings: StoreWriteSettings): void {
        if (prevStoreSettings) {
            this.maxConcurrentConnections = prevStoreSettings.maxConcurrentConnections;
            this.copyBehavior = prevStoreSettings.copyBehavior;
        }
    }
}
